export default __webpack_public_path__ + "assets/icons/ru.c47ebac0.svg";